import React, { useEffect, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";

import request from "graphql-request";
import { useAuth } from "../../../context/AuthContext/AuthContextProvider";

import BASEURL from "../../Utils/Baseurl";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, duration, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import PageLoading from "../../../components/Loading/PageLoading";
import {
  allWhatsapp,
} from "../callQuery";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import { getAllWhatsapp } from "./GraphQl";
import TableComponent from "../../../components/GridTable/TableComponent";

const WhatsAppLogList = () => {
  const [whatsappData, setWhatsappData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const isUser = currentUser?.role;
  const [row, setrow] = useState([]);

  useEffect(() => {
    fetchWhatsappData();
  }, []);
  
  const fetchWhatsappData = () => {
    setIsLoading(true);
    request(BASEURL, getAllWhatsapp)
      .then((res) => {   
      setWhatsappData(res.allWhatsappLogs.data);
    })
    .catch((error) => {
      console.error("Failed to fetch Whatsapp Log", error.response?.errors || error.message)
    })
    .finally(() => {
      setIsLoading(false);
    })
  };


  const whatsappListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        name: "S.NO",
        // flex: 1,
        width: 100,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Task",
        field: "task",
        name: "task",
        flex: 1,
        // width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Salesperson",
        field: "assignedTo",
        name: "assignedTo",
        flex: 1,
        // width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Chat Date",
        field: "chatDate",
        name: "chatDate",
        flex: 1,
        // width: 150,
        disableColumnMenu: true,
        editable: false,
      },

      {
        label: "Chat Start Time",
        field: "chatstartTime",
        name: "chatstartTime",
        flex: 1,
        // width: 150,
        disableColumnMenu: true,
        editable: false,
      },


      {
        label: "Chat Duration",
        field: "duration",
        name: "duration",
        flex: 1,
        // width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Outcome",
        field: "outcome",
        name: "outcome",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created At",
        field: "createdAt",
        name: "createdAt",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
  
    ],
    rows: whatsappData.map((val, index) => ({
      sno: index + 1,
      id: val.id,
      task: val.task.title,
      chatDate: val.chatDate,
      chatstartTime: val.chatstartTime,
      duration: val.duration,
      outcome: val.outcome,
      assignedTo: val.assignedTo.username,
      createdAt: val.createdAt.slice(0, 10)
    })),
  };

  const handleAddAppointmentForm = () => {
    navigate("/whatsapplog/add-whatsapp");
  };

  const onAppointmentForm = (e) => {
    if (e?.id) {
      navigate(`/whatsapplog/add-whatsapp?${e?.id}`);
    }
  };

  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
  const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }

  return (
    <DashboardLayout>
      <TableComponent
      tableLoading={isLoading ? true : false}
      columns={whatsappListTable.columns}
      rowsData={whatsappListTable.rows}
      head="Whatsapp List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onAppointmentForm}
      // onDelete={onDelete}
      onView={onAppointmentForm}
      onDeleteALL={onDeleteALL}
      addList={() => handleAddAppointmentForm()}
      />
      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  WhatsApp Log List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleAddAppointmentForm()}
              >
                Add WhatsApp Log
              </MaterialButton>
            </Stack>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            rows={appointmentListTable.rows}
            columns={appointmentListTable.columns}
            onRowClick={onAppointmentForm}
          />
        )}

        {isLoading && <PageLoading />}
      </Card> */}
    </DashboardLayout>
  );
};

export default WhatsAppLogList;
